

import Vue from "vue";

import {Project} from "@/models/base";

export default Vue.extend({
	props: {
		project: {
			required: true,
			type: Object as () => Project
		},
	},
	i18nEx: {
		componentPrefix: "components.project"
	}
});
